//@ts-nocheck
export const removeTrailingSlash = (str) => {
  if (!str) return;
  return str.replace('/', '');
};

export const doSomethingWithInput = (theInput) => {
  //Do something with the input
  return theInput;
};

export const justAnAlert = () => {
  alert('hello');
};

export const getUrlParam = (name) => {
  const url = window.location.href;
  name = name.replace('[', "\\[").replace(']', "\\]");
  const regex = new RegExp("[\\?&]" + name + "=([^&#]*)", "g");
  const matches = [];
  let match = regex.exec(url);

  while (match != null) {
    matches.push(match[1]);
    match = regex.exec(url);
  };

  return matches.length === 0 ? null : decodeURIComponent(matches[matches.length - 1]);
}

export const createCallUrl = () => {
  let pathname = window.location.pathname;
  url = pathname.split("/");
  let lang;
  let brand;
  if (url[3]) {
    lang = url[3].charAt(0) + url[3].slice(1);
  } else {
    lang = "in";
  }

  if (url[4]) {
    brand = url[4].charAt(0) + url[4].slice(1);
  } else {
    brand = "mc-desktop";
  }

  let s = getUrlParam('s');
  let level = getUrlParam('level');
  let url = "/ccaas/v2/call/" + brand + "?lang=" + lang;
  if (s) {
    url = url + "&s=" + s;
  }
  if (level) {
    url = url + "&level=" + level;
  }
  window.location.href = url;
}

export const createCallSelectorUrl = () => {
  let pathname = window.location.pathname;
  url = pathname.split("/");
  let lang;
  let brand;
  if (url[3]) {
    lang = url[3].charAt(0) + url[3].slice(1);
  } else {
    lang = "in";
  }

  if (url[4]) {
    brand = url[4].charAt(0) + url[4].slice(1);
  } else {
    brand = "mc-desktop";
  }

  let s = getUrlParam('s');
  let url = "/ccaas/v2/c/" + lang + "/" + brand + "?call=1";
  if (s) {
    url = url + "&s=" + s;
  }
  window.location.href = url;
}

export const decodeEntities = function (s) {
  let str, temp = document.createElement('p');
  temp.innerHTML = s;
  str = temp.textContent ?? temp.innerText;
  temp = null;
  return str;
}

export const capitalizeWords = (str) => {
  if (str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }
};

export const getUrlElement = (element) => {
  let currentUrl = window.location.href;
  currentUrl = currentUrl.split('?').slice(0)[0];
  const param = currentUrl.split('/').slice(0)[element];

  return param;
}

export const pullQueryString = (key) => {
  const urlParams = new URLSearchParams(window.location.search); // Parse the query string from the URL
  return urlParams.get(key); // Get the value of the query parameter by the key
};